module.exports = __webpack_public_path__ + "img/sell.53235549.svg";